import api from '@shared/services/api';

// Mark/unmark favorite or attendee
export type SetEventStatusPayload = {
  isFavorite?: boolean;
  isAttendee?: boolean;
};

export const setEventStatus = async (
  eventId: string,
  payload: SetEventStatusPayload
) => {
  return api.post(`/events/favorites/${eventId}/status`, payload);
};

// Get favorite/attendee status for a user and event
export const getUserStatus = async (
  eventId: string,
  userId: string
) => {
  const { data } = await api.get(`/events/favorites/${eventId}/user-status`, { params: { userId } });
  return data as { isFavorite: boolean; isAttendee: boolean };
};

// Get the list of inviteable members (friends/connections not already attending)
export const listInviteableMembers = async (eventId: string) => {
  const { data } = await api.get(`/events/favorites/${eventId}/inviteable-members`);
  return data as Array<{
    id: string;
    name: string;
    avatarUrl: string;
  }>;
};

// Get the list of attendees for an event
export const listAttendees = async (eventId: string) => {
  const { data } = await api.get(`/events/favorites/${eventId}/attendees`);
  return data as Array<{
    userId: string;
    isFavorite: boolean;
    isAttendee: boolean;
    // You can add more fields if your backend returns them
  }>;
};
